<script lang="ts">
    import { createEventDispatcher } from "svelte";

    import ButtonWithIcon from "@components/Buttons/ButtonWithIcon.svelte";
    import Icon from "@components/Icon.svelte";
    import CloseIcon from "@components/icons/CloseIcon.svelte";

    export let type: "text" | "tel" | "email" | "password" = "text";
    export let error = false;
    export let value = "";
    export let name = "";
    export let withClearIcon = false;

    const dispatch = createEventDispatcher();
    const onInput = (event: Event) => {
        if (event.target instanceof HTMLInputElement) {
            value = event.target.value;
            dispatch("change", { value: event.target.value, event });
        }
    };

    const onClear = () => {
        dispatch("change", { value: "" });
    };
</script>

<div class="gw-rv-text-input">
    <input
        class="gw-rv-text-input__input"
        class:gw-rv-text-input__input--error={error}
        {type}
        {value}
        {name}
        on:input={onInput}
        {...$$restProps}
    />

    {#if withClearIcon && value}
        <ButtonWithIcon class="gw-rv-text-input__clear-btn" on:click={onClear}>
            <Icon class="gw-rv-text-input__clear-icon">
                <CloseIcon />
            </Icon>
        </ButtonWithIcon>
    {/if}
</div>

<style lang="postcss">
    .gw-rv-text-input {
        --input-border-color: rgba(38, 40, 66, 0.12);
        --input-border-color-focus: #007995;

        position: relative;

        &__input {
            box-sizing: border-box;
            width: calc(100% - 2px);
            padding: 12px;
            border: 1px solid var(--input-border-color);
            border-radius: 10px;
            margin: 1px;
            font-size: 0.875em;
            line-height: 1.4em;
            background: transparent;
            outline: 0;
            font-family: inherit;
            color: inherit;

            &:focus,
            &:active {
                outline: none;
                border: 2px solid var(--input-border-color-focus);
                margin: 0;
            }

            &--error {
                border-color: var(--gw-error-color);
                color: var(--gw-error-color);
            }

            @media all and (max-width: 480px) {
                font-size: clamp(16px, 1em, 24px);
            }
        }
    }

    :global(.gw-rv-text-input__clear-btn) {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
    }

    :global(.gw-rv-text-input__clear-icon) {
        color: var(--gw-grey-reset-button-color);
    }
</style>
